import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import NotFound from "./Common/NotFound/NotFound";
import AddBoyan from "./Pages/Boyan/AddBoyan";
import SeeAllBoyan from "./Pages/Boyan/SeeAllBoyan";
import AddDoa from "./Pages/Doa/AddDoa";
import SeeAllDoa from "./Pages/Doa/SeeAllDoa";
import AddKitab from "./Pages/Kitab/AddKitab";
import SeeAllKitab from "./Pages/Kitab/SeeAllKitab";
import AddMasala from "./Pages/Masala/AddMasala";
import SeeAllMasala from "./Pages/Masala/SeeAllMasala";
import AddProbondho from "./Pages/Probondho/AddProbondho";
import SeeAllProbondho from "./Pages/Probondho/SeeAllProbondho";
import AddSalah from "./Pages/Salah/AddSalah";
import SeeAllSalah from "./Pages/Salah/SeeAllSalah";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createContext, useEffect, useState } from "react";
import AllKitabName from "./Pages/Kitab/AllKitabName";
import ShowAllCategory from "./Pages/Category/ShowAllCategory";
import Signup from "./Authentication/Signup";
import Login from "./Authentication/Login";
import PrivateRoute from "./Authentication/PrivateRoute";

export const AllContextData = createContext();

function App() {
    const [loggedInUser, setLoggedInUser] = useState({});
    const [detailsInfo, setDetailsInfo] = useState();

    useEffect(() => {
        const loggedInfo =  JSON.parse(sessionStorage.getItem('loggedInUser'));
        setLoggedInUser(loggedInfo);
        console.log(loggedInfo);
    },[])

  return (
    <AllContextData.Provider
    value={{
      loggedInUser,
      setLoggedInUser,
    }}
  >
    <Router>
        <ToastContainer />
      <Switch>
        <PrivateRoute exact path="/">
            <AddMasala/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allMasala">
            <SeeAllMasala/>
        </PrivateRoute>
        <PrivateRoute path="/admin/addBoyan">
            <AddBoyan/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allBoyan">
            <SeeAllBoyan/>
        </PrivateRoute>
        <PrivateRoute path="/admin/addDoa">
            <AddDoa/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allDoa">
            <SeeAllDoa/>
        </PrivateRoute>
        <PrivateRoute path="/admin/addProbondho">
            <AddProbondho/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allProbondho">
            <SeeAllProbondho/>
        </PrivateRoute>
        <PrivateRoute path="/admin/addSalah">
            <AddSalah/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allSalah">
            <SeeAllSalah/>
        </PrivateRoute>
        <PrivateRoute path="/admin/addKitab">
            <AddKitab/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allKitab">
            <SeeAllKitab/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allKitabName">
            <AllKitabName/>
        </PrivateRoute>
        <PrivateRoute path="/admin/allCategory">
            <ShowAllCategory/>
        </PrivateRoute>

        <Route path="/admin/login">
             <Login/>            
        </Route>
       
        <Route path="/admin/signup">
             <Signup/>            
        </Route>

        <Route path="*">
            <NotFound/>
        </Route>
      </Switch>
    </Router>
    </AllContextData.Provider>
  );
}

export default App;
